<template>
    <v-card class="ma-2">
        <report-table class="ma-2"/>
    </v-card>
</template>

<script>
	import ReportTable from "../components/ReportTable";
	export default {
		name: "ReportsView",
		components: {ReportTable}
	}
</script>

<style scoped>

</style>
